import { Component, forwardRef, OnChanges, OnInit } from '@angular/core';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { AbstractFormFieldComponent } from '../../../PageBuilder/components/FormField/abstract-form-field.component';
import { RadioButtonsFieldComponent } from '../../../PageBuilder/components/FormFields/RadioButtonsField/radio-buttons-field.component';
import { dynamicBlockComponentMap, dynamicDashboardBlockComponentMap } from '../../models/reports-block-types.model';
import { RadioButtonOptionModel } from '../../../Forms/models/radio-button-option.model';
import { ChartDisplayElementModel } from '../../models/chart-display-element.model';
import { SeriesTypeEnum } from '../../enums/series-type.enum';
import { TermTypesEnum } from '../../enums/term-types.enum';
import { ChartMetricsEnum } from '@Common/Reports/enums/chart-metrics.enum';

@Component({
    selector: 'agpr-term-types-radio-buttons-field',
    templateUrl: '../../../PageBuilder/components/FormFields/RadioButtonsField/radio-buttons-field.component.html',
    styleUrls: ['../../../PageBuilder/components/FormFields/RadioButtonsField/radio-buttons-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => TermTypesRadioButtonsFieldComponent)
        }
    ],
    standalone: false
})
export class TermTypesRadioButtonsFieldComponent extends RadioButtonsFieldComponent implements OnInit, OnChanges {
    readonly savedSources = [
        SeriesTypeEnum.folder,
        SeriesTypeEnum.tag,
        SeriesTypeEnum.tagGroup,
        SeriesTypeEnum.sourceGroup,
        SeriesTypeEnum.aiAgent,
    ];

    constructor(protected localizationService: LocalizationService) {
        super(localizationService);
    }

    ngOnInit(): void {
        this.useChartPrefColors = !!(this.field?.useChartPrefColors);

        this.setSelectedOption();
    }

    ngOnChanges(): void {
        // NEP-19055 -> removing handles until NEP-19059 is done
        if (this.field?.property === 'termType') {
            const type = (this.block.displayElement as ChartDisplayElementModel)?._series?.[0].type;
            if (this.savedSources.includes(type)) {
                this.field.options = [
                    new RadioButtonOptionModel('Reports.term.type.hashtags', TermTypesEnum.HASHTAGS),
                    new RadioButtonOptionModel('Reports.term.type.words', TermTypesEnum.WORDS)
                ];
                if ((this.value !== TermTypesEnum.HASHTAGS) && (this.value !== TermTypesEnum.WORDS)) {
                    this.selectedOption = TermTypesEnum.HASHTAGS;
                    this.onRadioButtonChanged(this.field.options[0]);
                }
            } else {
                // copied from reports-block-types.model.ts
                this.field.options = [
                    new RadioButtonOptionModel('Reports.term.type.hashtags', TermTypesEnum.HASHTAGS),
                    new RadioButtonOptionModel('Reports.term.type.handles', TermTypesEnum.HANDLES),
                    new RadioButtonOptionModel('Reports.term.type.words', TermTypesEnum.WORDS),
                ];
            }

            const metric = (this.block.displayElement as ChartDisplayElementModel)?.metric;
            if (metric !== ChartMetricsEnum.VOLUME) {
                this.field.options = this.field.options.filter(option => option.key !== TermTypesEnum.WORDS);
                if (this.value === TermTypesEnum.WORDS) {
                    this.selectedOption = TermTypesEnum.HASHTAGS;
                    this.onRadioButtonChanged(this.field.options[0]);
                }
            }
        }
    }

    override onRadioButtonChanged(option: RadioButtonOptionModel) {
        this.selectedSubOption = this.selectedOption;
        this.value = this.selectedSubOption;
        this.changes.emit(this.value);
        this.checkComponentChange();
    }

    override setSelectedOption(): void {
        super.setSelectedOption();
        this.checkComponentChange();
    }

    private checkComponentChange(): void {
        if (this.field.dynamicComponentType) {
            if (this.block.type.isDashboard) {
                this.block.type.componentType = dynamicDashboardBlockComponentMap.get(this.value);
            } else {
                this.block.type.componentType = dynamicBlockComponentMap.get(this.value);
            }
            this.block.componentChange$.next(true);
        }
    }
}
